export default "__VITE_ASSET__P71bGhlU__"